// Core Modules
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-section-card',
  templateUrl: './section-card.component.html',
  styleUrl: './section-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionCardComponent {
  /** Optional card heading; when omitted the header row is not rendered. */
  public readonly heading = input<string>();
  /** Optional muted suffix appended after the heading (e.g. "· CLIENTCODE"). */
  public readonly headingSuffix = input<string>();
  /** Visual variant. `'success'` tints the card (background + border) for a positive/"configured" state. */
  public readonly variant = input<'default' | 'success'>('default');
}
